module.exports = __webpack_public_path__ + "static/project-21a-2ceeb40fd4f67234566fbd3806bb4416.png";